// extracted by mini-css-extract-plugin
export default {"root":"TopBar_root__-UC1M"};